export function getSelectedFiltersBySkus(selectedSkus, filters) {
  const newFilter = {};

  Object.keys(filters)?.forEach(key => {
    newFilter[key] = filters[key]?.filter(
      filter => selectedSkus.filter(sku => sku.attrs[key] === filter.value).length > 0
    );
  });

  return newFilter;
}
